import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    Order,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import requests from 'app/requests/Order/Order.requests'

const useGetOrderByNumber = (orderNumber: string) => {
    return useRequest<Order>({
        key: RequestKeys.getOrderByNumber,
        params: {
            id: orderNumber,
        },
        requestFunc: RequestFn.getEntity(requests.getOrderById),
        enabled: Boolean(orderNumber),
        keepPreviousData: true,
    })
}

export default useGetOrderByNumber
